import IpIntrusion from './ip-intrusion';

export default function IpIntrusionPage() {
  return <IpIntrusion />;
}
